import ISO6391 from 'iso-639-1';
import { SUPPORTED_LANGUAGES } from '@wundo/shared/language.ts';

export type Language = string;

const allLanguages = ISO6391.getLanguages(ISO6391.getAllCodes())
  .map((lang) => ({ value: lang.code, label: lang.name }))
  .sort((a, b) => a.label.localeCompare(b.label));

const commonLanguages = SUPPORTED_LANGUAGES.map((code) =>
  allLanguages.find((lang) => lang.value === code)!,
).sort((a, b) => a.label.localeCompare(b.label));

const otherLanguages = allLanguages.filter(
  (lang) => !(SUPPORTED_LANGUAGES as readonly string[]).includes(lang.value),
);

export const languageOptions = [
  ...commonLanguages,
  { value: '---', label: '──────────', disabled: true },
  ...otherLanguages,
];

/**
 * "Automatic" in a language select: nobody chooses, so the person's first
 * contact — their Teams client or their browser — fills the language in.
 * Not a language code, so it can never be mistaken for one.
 */
export const AUTOMATIC_LANGUAGE = 'automatic';
